var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "#1D1E2C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.43 21.578c.28.273.636.422 1.056.422.84 0 1.514-.645 1.514-1.463 0-.41-.178-.782-.47-1.067l-8.905-8.482L12.53 2.53c.293-.285.471-.67.471-1.067C13 .645 12.326 0 11.486 0c-.42 0-.776.149-1.056.422L.534 9.847A1.568 1.568 0 000 11c0 .434.178.806.534 1.14l9.896 9.438z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.eecd35858b0f3d1d34afe7662a29faf9.svg";
export { ForwardRef as ReactComponent };